import { isEqual } from 'lodash';

export function inArray<T>(item: T, selectedItems: T[]): boolean {
  return selectedItems.some((selectedItem: T) => isEqual(item, selectedItem));
}
